define(["exports", "../core/l10n", "hyperhtml", "../core/pubsubhub", "../core/exporter", "../core/ui"], function (_exports, _l10n, _hyperhtml, _pubsubhub, _exporter, _ui) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.exportDocument = exportDocument;
  _exports.name = void 0;
  _hyperhtml = _interopRequireDefault(_hyperhtml);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _templateObject2() {
    const data = _taggedTemplateLiteral(["\n      <div class=\"respec-save-buttons\">\n        ", "\n      </div>"]);

    _templateObject2 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject() {
    const data = _taggedTemplateLiteral(["\n    <a\n      href=\"", "\"\n      id=\"", "\"\n      download=\"", "\"\n      type=\"", "\"\n      class=\"respec-save-button\"\n      onclick=", "\n    >", "</a>"]);

    _templateObject = function _templateObject() {
      return data;
    };

    return data;
  }

  function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

  const name = "ui/save-html"; // Create and download an EPUB 3 version of the content
  // Using (by default) the EPUB 3 conversion service set up at labs.w3.org/epub-generator
  // For more details on that service, see https://github.com/iherman/respec2epub

  _exports.name = name;
  const epubURL = new URL("https://labs.w3.org/epub-generator/cgi-bin/epub-generator.py");
  epubURL.searchParams.append("type", "respec");
  epubURL.searchParams.append("url", document.location.href);
  const downloadLinks = [{
    id: "respec-save-as-html",
    fileName: "index.html",
    title: "HTML",
    type: "text/html",

    get href() {
      return (0, _exporter.rsDocToDataURL)(this.type);
    }

  }, {
    id: "respec-save-as-xml",
    fileName: "index.xhtml",
    title: "XML",
    type: "application/xml",

    get href() {
      return (0, _exporter.rsDocToDataURL)(this.type);
    }

  }, {
    id: "respec-save-as-epub",
    fileName: "spec.epub",
    title: "EPUB 3",
    type: "application/epub+zip",
    href: epubURL.href
  }];

  function toDownloadLink(details) {
    const {
      id,
      href,
      fileName,
      title,
      type
    } = details;
    return (0, _hyperhtml.default)(_templateObject(), href, id, fileName, type, () => _ui.ui.closeModal(), title);
  }

  const saveDialog = {
    async show(button) {
      await document.respecIsReady;
      const div = (0, _hyperhtml.default)(_templateObject2(), downloadLinks.map(toDownloadLink));

      _ui.ui.freshModal(_l10n.l10n[_l10n.lang].save_snapshot, div, button);
    }

  };
  const supportsDownload = "download" in HTMLAnchorElement.prototype;
  let button;

  if (supportsDownload) {
    button = _ui.ui.addCommand(_l10n.l10n[_l10n.lang].save_snapshot, show, "Ctrl+Shift+Alt+S", "💾");
  }

  function show() {
    if (!supportsDownload) return;
    saveDialog.show(button);
  }
  /**
   * @param {*} _
   * @param {string} mimeType
   */


  function exportDocument(_, mimeType) {
    const msg = "Exporting via ui/save-html module's `exportDocument()` is deprecated and will be removed. " + "Use core/exporter `rsDocToDataURL()` instead.";
    (0, _pubsubhub.pub)("warn", msg);
    console.warn(msg);
    return (0, _exporter.rsDocToDataURL)(mimeType);
  }
});
//# sourceMappingURL=save-html.js.map